module.exports = "/assets/c9ab5d2f79f4259265b38df592fe61ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/IX.png
// module id = 2615
// module chunks = 0